<template>
  <div>
    <el-container>
      <el-header>
        <el-date-picker
          v-model="time"
          type="daterange"
          value-format="timestamp"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
        <el-button type="primary" @click="isAjax" plain>查询</el-button>
      </el-header>
      <el-main v-loading.fullscreen.lock="fullscreenLoading">
        <template>
          <el-table
            :data="tableData"
            border
            :height="divHeight"
            style="width: 100%">
            <el-table-column
              fixed
              prop="weChatUserPlatform.authorizer_info.nick_name"
              label="公众号名称"
              width="200">
            </el-table-column>
            <el-table-column
              prop="weChatUserPlatform.authorizer_info.principal_name"
              label="所属公司"
              width="320">
            </el-table-column>
            <el-table-column
              prop="user_source"
              label="用户的渠道"
              width="280">
              <template slot-scope="scope">
                <span v-html="isSex(scope.row.user_source)"></span>
              </template>
            </el-table-column>
            <el-table-column
              prop="date_time"
              label="统计日期"
              width="150">
            </el-table-column>
            <el-table-column
              prop="new_user"
              label="新增用户数"
              width="180">
            </el-table-column>
            <el-table-column
              prop="cancel_user"
              label="取消关注数量"
              width="180">
            </el-table-column>
          </el-table>
        </template>
      </el-main>
      <el-footer>
        <el-pagination
          background
          @size-change="handleSizeChange0"
          @current-change="handleCurrentChange0"
          :current-page="currentPage0"
          :page-sizes="[100, 200, 300, 400]"
          :page-size="count0"
          layout="total, sizes, prev, pager, next, jumper"
          :total="allcount0">
        </el-pagination>
      </el-footer>
    </el-container>
  </div>
</template>
<script>
  import apiController from '@/api/weChat'
  export default {
    name: 'fanManage',
    data(){
      return {
        time:"",
        fullscreenLoading: false,
        allcount0:0,//总页数 对应 total
        count0:100,//一页显示多少量 对应 page-size
        currentPage0:1,//当前页数
        divHeight:500,
        tableData:[]
      }
    },
    components: {
    },
    methods:{
      isSex(sex){
        let mess = ''
        switch (sex) {
          case 0:
            mess = '其他'
            break;
          case 1:
            mess = '公众号搜索'
            break;
          case 17:
            mess = '名片分享'
            break;
          case 30:
            mess = '扫描二维码'
            break;
          case 51:
            mess = '支付后关注'
            break;
          case 57:
            mess = '文章内账号名称'
            break;
          case 100:
            mess = '微信广告'
            break;
          case 161:
            mess = '他人转载'
            break;
          case 176:
            mess = '专辑页内账号名称'
            break;
        }
        return mess
      },
      formatTime:function(row, column) {
        var date = new Date(parseInt(row[column.property]+'000'));
        var format = "yyyy-MM-dd hh:mm:ss";
        var o = {
          "M+" : date.getMonth()+1, //month
          "d+" : date.getDate(),    //day
          "h+" : date.getHours(),   //hour
          "m+" : date.getMinutes(), //minute
          "s+" : date.getSeconds(), //second
          "q+" : Math.floor((date.getMonth()+3)/3),  //quarter
          "S" : date.getMilliseconds() //millisecond
        };
        if(/(y+)/.test(format)) format=format.replace(RegExp.$1,
          (date.getFullYear()+"").substr(4 - RegExp.$1.length));
        for(var k in o)if(new RegExp("("+ k +")").test(format))
          format = format.replace(RegExp.$1,
            RegExp.$1.length==1 ? o[k] :
              ("00"+ o[k]).substr((""+ o[k]).length));
        return format;
      },
      isAjax:async function(){
        await apiController.getUserAnalysis({
          params:{
            t:this.time,
            limit: this.count0,
            page: this.currentPage0
          }
        })
          .then(res => {
            let { data, code } = res.data
            if (code === 'Success'){
              this.tableData = data[0]
              this.allcount0 = data[1]
            }
          })
          .catch((error) => {
            this.$message.error(JSON.stringify(error));
          })
      },
      handleSizeChange0(val) {
        this.count0 = val;
        this.isAjax();
      },
      handleCurrentChange0(val) {
        this.currentPage0 = val;
        this.isAjax();
      },
    },
    mounted(){
      this.isAjax();
    }
  }
</script>
<style scoped>
  body{
    padding: 0;
    margin: 0;
  }
  .headimgurl{
    width: 100px;
    height: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/views/weChatPlatfrom/userAnalysis.vue